$(function () {	
	var blogListPagesize = $('#blog-page-size').val(),
		blogListFilterVal, blogSegmentListFilterVal, hashParamObj, firstPage = 1, currentPage = firstPage,
		IsUserAuthenticated = $('#blog-user-is-authenticated').val(),
		clearBlogFiltersBtn = $("#clearBlogFilters"),
		blogSegmentsLavel = "", blogTopicsLavel = "";

		clearBlogFiltersBtn.hide();

	var updateFilter = function(selector, facet, paramName) {

		const urlParams = new URLSearchParams(window.location.search);
		const selected = urlParams.get(paramName) || "";

		const $ul = $(selector);

		let html = ""
		if (facet && facet.values) {
			html = `
				<li data-list-value="" class="${selected === "" ? "active" : ""}">
					${facet.label}
				</li>
			`;

			facet.values.forEach(v => {
				if (!v.count || v.count === 0) return;

				const isActive = selected === v.id;
				
				html += `
					<li data-list-value="${v.id}" class="${isActive ? "active" : ""}">
						${v.name}
						${isActive ? '<a class="clear-filter" href="javascript:void(0);">×</a>' : ""}
					</li>
				`;
			});
		}

		$ul.html(html);
		$ul.closest(".custom-select").removeClass("open").find(".custom-select-list-box").hide();
	}

	function applySelectedValue(selector, selectedValue) {
        const $custom = $(selector).closest(".custom-select");
        const $li = $custom.find(".custom-select-list li[data-list-value='" + selectedValue + "']");

        if ($li.length) {
            $li.addClass("active").siblings().removeClass("active");
            $custom.find(".custom-select-value").val($li.text().trim());
        }
    }

	function renderBlogList(data, pageNo, pageSize) {
		var blogListData = "";

		data.blogList.forEach(item => {
			blogListData += `
				<div class="tile-list thumbnail">
					<div class="tile-list-thumbnail">
						<img 
							src="${item.image && item.image[0] ? item.image[0] : '/-/media/tech/omdia/herobannerwithtile/herobannerwithtileplaceholder.jpeg'}" 
							alt="${item.image && item.image[1] ? item.image[1] : 'placeholder-img'}">
					</div>
					<div class="tile-list-content">

						<label class="action-flag pop-out__trigger ${IsUserAuthenticated ? "js-bookmark-article" : "js-pop-out-trigger"}"
							data-pop-out-type="sign-in"
							data-pop-out-align="right"
							data-bookmark-id="${item.itemId}"
							${item.blogSalesforceId ? `data-salesforce-id="${item.blogSalesforceId}"` : `data-salesforce-id`}
							${item.isBookMarked ? "data-is-bookmarked=true" : ""}
							data-info='{
								"event_name": "${item.isBookMarked ? "unbookmark" : "bookmark"}",
								"toolbar_tool": "bookmark",
								"bookmark_title": "${item.title}"
							}'>

							<svg class="action-flag__icon action-flag__icon--bookmark article-bookmark article-bookmark__bookmarked ${item.isBookMarked ? "is-visible" : ""}">
								<use xlink:href="/dist/img/svg-sprite.svg#bookmark_filled"></use>
							</svg>

							<svg class="action-flag__icon action-flag__icon--bookmark article-bookmark ${item.isBookMarked ? "" : "is-visible"}">
								<use xlink:href="/dist/img/svg-sprite.svg#bookmark_border"></use>
							</svg>
						</label>

						<h3 class="tile-list-title"><a href="${item.url}">${item.title}</a></h3>

						<div class="tile-list-metas">
							<span>${item.publicationDate}</span>
						</div>

						<p>${item.summary || ""}</p>

						<a href="${item.url}" target="_blank" class="cta cta-large cta-secondary">Read more</a>
					</div>
				</div>`;
		});

		$("#blogListDataFromFrontend").html(blogListData);
		$("#blogListPagination").pagination({
			dataTotalLength: data.count,
			currentPageItem: pageNo,
			dataPerPage: pageSize
		});

		window.indexPopOuts();
		window.indexBookmarks();
	}

	var fetchBlogListData = function(pageNo, pageSize){		
		$("#blogListPaginationBackend").hide();
		$("#blogListDataFromBackend").hide();
		var segmentsFacet = null;
		var topicsFacet = null;

		$.post("/api/blogsfilter/getblogitems", {
		// $.get("/api-json/blog-list.json", {
			"TaxonomyID": blogListFilterVal,
			"SegmentID": blogSegmentListFilterVal,
			"PageNo" : pageNo,
			"PageSize": pageSize
        }, function (data) {

			if (data && data.respone && data.respone.facets) {
				segmentsFacet = data.respone.facets.find(f => f.id === "segments");
				topicsFacet   = data.respone.facets.find(f => f.id === "topics");

				blogSegmentsLavel = segmentsFacet ? segmentsFacet.label : ""; 
				blogTopicsLavel = topicsFacet ? topicsFacet.label : "";
			}

			// if (data && data.facets) {
			// 	segmentsFacet = data.facets.find(f => f.id === "segments");
			// 	topicsFacet   = data.facets.find(f => f.id === "topics");

			// 	blogSegmentsLavel = segmentsFacet ? segmentsFacet.label : "";
			// 	blogTopicsLavel = topicsFacet ? topicsFacet.label : "";
			// }

			// ---- NEW : Update dropdown options ----
			updateFilter("#blogSegmentListFilter .custom-select-list", segmentsFacet, "SegmentID");
			updateFilter("#blogListFilter .custom-select-list", topicsFacet, "TaxonomyID");

			applySelectedValue("#blogSegmentListFilter .custom-select-list", blogSegmentListFilterVal);
            applySelectedValue("#blogListFilter .custom-select-list", blogListFilterVal);

			// ------------------ RENDER BLOG LIST -------------------------
            renderBlogList(data.respone, pageNo, pageSize);
        });
    }
	
	var updateHashParam = function updateHashParam(key, value) {
		const params = new URLSearchParams(window.location.search);

		// SET or DELETE
		if (value) {
			params.set(key, value);
		} else {
			params.delete(key);
		}

		// SPECIAL CASE: page
		if (key === "page" && (!value || value < 2)) {
			params.delete("page");
		}

		const query = params.toString();
		const newUrl =
			window.location.protocol +
			"//" +
			window.location.host +
			window.location.pathname +
			(query ? "?" + query : "");

		window.history.pushState({ path: newUrl }, "", newUrl);
	};

	function syncFilterState({value, filterSelector, valueSetter, defaultLabel }) {
		if (typeof value === "undefined") return;

		// Update JS variable
		valueSetter(value);

		// Update UI
		const $filter = $(filterSelector);
		const $items = $filter.find(".custom-select-list li");
		
		if (value) {
			const $matched = $items.filter(function () {
				return $(this).attr("data-list-value") === value;
			});

			if ($matched.length) {
				$matched.addClass("active").siblings().removeClass("active");
				$filter.find("input").val($matched.text().trim());
			}
		} else {
			$items.removeClass("active").first().addClass("active");
			$filter.find(".custom-select-value").val(defaultLabel);
		}

		// Show / hide Clear button
		if (blogListFilterVal || blogSegmentListFilterVal) {
			clearBlogFiltersBtn.show();
		} else {
			clearBlogFiltersBtn.hide();
		}
	}

		
	var hashParam = new URLSearchParams(window.location.search);
	if (hashParam) {
		if(hashParam.get("TaxonomyID")){
			blogListFilterVal = hashParam.get("TaxonomyID");
			
			$("#blogListFilter .custom-select-list li").each(function(){
				if($(this).attr('data-list-value') === hashParam.get("TaxonomyID")){
					$(this).addClass("active").siblings().removeClass("active");
					$("#blogListFilter input").val($(this).text());
				}
			})
		}
		if(hashParam.get("SegmentID")){
			blogSegmentListFilterVal = hashParam.get("SegmentID");
			
			$("#blogSegmentListFilter .custom-select-list li").each(function(){
				if($(this).attr('data-list-value') === hashParam.get("SegmentID")){
					$(this).addClass("active").siblings().removeClass("active");
					$("#blogSegmentListFilter input").val($(this).text());
				}
			})
		}
		// blogListFilterVal = hashParam.get("TaxonomyID") || "";
		// blogSegmentListFilterVal = hashParam.get("SegmentID") || "";
		// $("#blogListFilter input").val($(this).text());
		// $("#blogSegmentListFilter input").val($(this).text());

		if (blogListFilterVal || blogSegmentListFilterVal) {
			clearBlogFiltersBtn.show();
		}
	}
	
	if(blogListPagesize) {
		if(hashParam.get("page")){
			fetchBlogListData(hashParam.get("page"), blogListPagesize);
			$('link[rel="canonical"]').attr('href', window.location);
		} else {
			fetchBlogListData(firstPage, blogListPagesize);
		}
	}
	
	$("#blogListPagination").on('click', "li", function (e) {
		e.preventDefault();
		var pageIndex = $(this).find("a").attr("data-index");
		currentPage = pageIndex;
		updateHashParam("page", pageIndex);
		fetchBlogListData(pageIndex, blogListPagesize);
		$('link[rel="canonical"]').attr('href', window.location);
	});

	$("#blogSegmentListFilter").on('click', '.custom-select-list li', function () {
		syncFilterState({
			value: $(this).attr("data-list-value"),
			filterSelector: "#blogSegmentListFilter",
			valueSetter: (val) => (blogSegmentListFilterVal = val),
			defaultLabel: blogSegmentsLavel
		});

		fetchBlogListData(firstPage, blogListPagesize);
		updateHashParam("SegmentID", blogSegmentListFilterVal);
		updateHashParam('page', "");
		$("#blogListPagination").pagination({
			currentPageItem: firstPage,
		});
	});
	
	$("#blogListFilter").on('click', '.custom-select-list li', function () {
		syncFilterState({
			value: $(this).attr("data-list-value"),
			filterSelector: "#blogListFilter",
			valueSetter: (val) => (blogListFilterVal = val),
			defaultLabel: blogTopicsLavel
		});

		fetchBlogListData(firstPage, blogListPagesize);
		updateHashParam("TaxonomyID", blogListFilterVal);
		updateHashParam('page', "");
		$("#blogListPagination").pagination({
			currentPageItem: firstPage,
		});
	});

	clearBlogFiltersBtn.on("click", function () {
		syncFilterState({
			value: "",
			filterSelector: "#blogListFilter",
			valueSetter: (val) => (blogListFilterVal = val),
			defaultLabel: blogTopicsLavel
		});

		syncFilterState({
			value: "",
			filterSelector: "#blogSegmentListFilter",
			valueSetter: (val) => (blogSegmentListFilterVal = val),
			defaultLabel: blogSegmentsLavel
		});

		updateHashParam("TaxonomyID", "");
		updateHashParam("SegmentID", "");
		updateHashParam("page", "");

		currentPage = firstPage;
		fetchBlogListData(firstPage, blogListPagesize);

		$("#blogListPagination").pagination({
			currentPageItem: firstPage
		});
	});

	$(document).on("click", ".blogs-filter-item .custom-select .clear-filter", function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $li = $(this).closest("li");
		const $filter = $li.closest(".custom-select");

		// Identify which dropdown
		if ($filter.is("#blogSegmentListFilter")) {
			blogSegmentListFilterVal = "";
			updateHashParam("SegmentID", "");
		} else if ($filter.is("#blogListFilter")) {
			blogListFilterVal = "";
			updateHashParam("TaxonomyID", "");
		}

		// Reset UI
		$filter.find(".custom-select-list li")
			.removeClass("active")
			.first()
			.addClass("active");

		$filter.find(".custom-select-value").val(
			$filter.is("#blogSegmentListFilter") ? blogSegmentsLavel : blogTopicsLavel
		);

		// Page reset
		updateHashParam("page", "");

		// Reload
		fetchBlogListData(firstPage, blogListPagesize);
		$("#blogListPagination").pagination({ currentPageItem: firstPage });

		// Toggle global clear
		if (blogSegmentListFilterVal || blogListFilterVal) {
			clearBlogFiltersBtn.show();
		} else {
			clearBlogFiltersBtn.hide();
		}
	});
	
	var blogFeedUrl = $("#blogFeedUrl").val();
	$("#blogFeedData").click(function(){
		if(blogListFilterVal && blogSegmentListFilterVal){
			var url = blogFeedUrl + "?PageNo=" + currentPage + "&PageSize=" + blogListPagesize + "&TaxonomyID=" + blogListFilterVal + "&SegmentID=" + blogSegmentListFilterVal;
			window.open(url, '_blank');
		}else if(blogListFilterVal){
			var url = blogFeedUrl + "?PageNo=" + currentPage + "&PageSize=" + blogListPagesize + "&TaxonomyID=" + blogListFilterVal
			window.open(url, '_blank');
		}else if(blogSegmentListFilterVal){
			var url = blogFeedUrl + "?PageNo=" + currentPage + "&PageSize=" + blogListPagesize + "&SegmentID=" + blogSegmentListFilterVal;
			window.open(url, '_blank');
		}
		else{
			var url = blogFeedUrl + "?PageNo=" + currentPage + "&PageSize=" + blogListPagesize;
			window.open(url, '_blank');
		}
	});

    $.fn.pagination = function (options) {		
		var _this = this,
			defaults = {
				dataPerPage: 10,
				populatePageCount: 5,
				startPageFrom: 1,
			},
			settings = $.extend({}, defaults, options),
			firstPageIndex = 1,
			initPageIndex = settings.startPageFrom,
			lastPageIndex = settings.populatePageCount,
			pageIncrement,
			activePageIndex = 1,
			totalPageCount = "",
			currentPageItem = settings.currentPageItem;
			
			
		if(this.length > 1){
			this.each(function(){ $(this).pagination(options) });
			return this;
		}
	
		this.populateData = function(){
			totalPageCount = Math.ceil(settings.dataTotalLength / settings.dataPerPage);
			var paginationItem = "";
				
			if(initPageIndex != firstPageIndex){
				paginationItem += `<li>
									<a href="#?page=${firstPageIndex}" data-index="${firstPageIndex}" title="Page ${firstPageIndex}">First</a>
								   </li>
								   <li>...</li>`;
			}
			
			for (var i = initPageIndex; i <= totalPageCount; i++) {
				if(i <= lastPageIndex){
					if(activePageIndex && activePageIndex == i){
						paginationItem += `<li class="active">
											<a href="#?page=${i}" data-index="${i}" title="Page ${i}">${i}</a>
										  </li>`;
					}else{					
						paginationItem += `<li>
											<a href="#?page=${i}" data-index="${i}" title="Page ${i}">${i}</a>
										  </li>`;
					}
				}
			}
			
			if(totalPageCount > lastPageIndex){
				paginationItem += `<li>...</li>`
				
				if(totalPageCount == activePageIndex){
					paginationItem += `<li class"active">
										<a href="#?page=${totalPageCount}" data-index="${totalPageCount}" title="Page ${totalPageCount}">Last</a>
									  </li>`;
				}else {
					paginationItem += `<li>
										<a href="#?page=${totalPageCount}" data-index="${totalPageCount}" title="Page ${totalPageCount}">Last</a>
									  </li>`;
				}
			}
			
			if (totalPageCount <= firstPageIndex) {
				paginationItem = "";
			}			
			this.html(paginationItem);	
		}
		
		this.initialize = function(){
			_this.populateData();
				
			if(currentPageItem){
				activePageIndex = currentPageItem;
			}

			if (currentPageItem && currentPageItem > 2 && currentPageItem <= totalPageCount - 2) {
				initPageIndex = Number(currentPageItem) - 2;
				lastPageIndex = Number(currentPageItem) + 2;
			}
			if (currentPageItem && currentPageItem <= 2) {
				initPageIndex = settings.startPageFrom,
				lastPageIndex = settings.populatePageCount
			}
			if(totalPageCount > 5){
				if (currentPageItem && currentPageItem >= totalPageCount - 2) {
					initPageIndex = totalPageCount - 4;
					lastPageIndex = totalPageCount;
				}
			}
			_this.populateData();
		};
		this.initialize();		
			
		$(_this).on('click', "li", function(e){
			e.preventDefault();
			//e.stopPropagation();
			currentPageItem = $(this).find("a").attr("data-index");
			_this.initialize();
		});
	};
});